import { required } from '../../../helpers'
import Rule from '../Rule'

export default class Required extends Rule {
  get ruleName () {
    return 'required'
  }

  passes () {
    return required(this.value)
  }
}
